import { CONTACT_AGREEMENTS_LOADING, GET_CONTACT_AGREEMENTS } from './agreementTypes'

const initState = {
  loading: false,
  data: {
    data: [],
    query: { first: 0, limit: 5, totalRecords: 0 },
  },
}

const ContactAgreementsReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_CONTACT_AGREEMENTS:
      return {
        ...state,
        data: action.payload,
      }
    case CONTACT_AGREEMENTS_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

export default ContactAgreementsReducer
